import { getClipSnapSiteOrigin, getClipSnapToolLink } from "./externalEditors";

/**
 * The AI Photo Editing footer section, powered by ClipSnap. These are plain marketing links, so
 * they always point at the public ClipSnap site (the env-driven host is only for file hand-offs).
 */
export const footerAiTools = [
    { title: "remove-background", link: getClipSnapToolLink("background-remover") },
    { title: "enhance-quality", link: getClipSnapToolLink("image-enhancer") },
    { title: "upscale-with-ai", link: getClipSnapToolLink("image-upscaler") },
    { title: "white-background", link: getClipSnapToolLink("white-background") },
    { title: "generative-fill", link: getClipSnapToolLink("generative-fill") },
    { title: "ai-image-editor", link: `${getClipSnapSiteOrigin()}/create/` },
] as const;

export const footerPoweredByClipSnapLink = getClipSnapSiteOrigin();

export const footerPdfToolsCardLink = "https://www.propdf.com";

/** "Featured Products" row, in the approved branding order. */
export const footerFeaturedProducts = [
    { name: "ProPDF", link: "https://www.propdf.com" },
    { name: "ClipSnap", link: getClipSnapSiteOrigin() },
    { name: "FreeConvert", link: "https://www.freeconvert.com" },
    { name: "PhotoJoiner", link: "https://www.photojoiner.net" },
] as const;
